import { maxLength, prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { RateLine } from "../../rates/_types/rate-line";
import { Transaction } from "./transaction";
import { TransactionLineTemplate } from "./transaction-line-template";
import { Job } from "../../cases/_types/job";
import { User } from "../../users/_types/user";

export class TransactionLog extends Resource {
    public override type = 'transactionLogs';
    

    @prop()
    @required()
    public transactionId!: string;

    @propObject(Transaction)
    public transaction!: Transaction;
    
    @prop()
    @required()
    public date!: Date; 

    @propObject()
    public createdByUser?: User;

    @prop() 
    @maxLength({value: 2000})       
    public notes!: string ;  

}